import React from "react";
import SectionTitle from "../../components/layouts/others/title-section.layout";
import { Box, Chip, Container, Divider, Paper, Stack, Typography, Button } from "@mui/material";
import Grid from "@mui/material/Grid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faCamera,
    faMedal,
    faShieldHalved,
    faIndustry,
    faPeopleGroup,
    faBullhorn,
    faUserTie,
    faSchool,
    faHandshakeAngle,
    faFlag,
    faTriangleExclamation,
    faLandmark,
    faUsers,
    faCheckCircle,
    faComments,
    faMagnifyingGlass,
    faGavel,
    faClipboardList,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

// @ts-ignore
import imgJpg from "../../assets/images/others/jpg-5.png";

const POST20260114: React.FC = () => {
    const Pill = ({ icon, label }: { icon: any; label: string }) => (
        <Chip
            icon={<FontAwesomeIcon icon={icon} style={{ color: "#1565c0" }} />}
            label={label}
            sx={{
                bgcolor: "rgba(21,101,192,0.08)",
                color: "#1565c0",
                fontWeight: 800,
                borderRadius: 3,
                px: 0.75,
            }}
        />
    );

    const Bullet = ({ icon, children }: { icon: any; children: React.ReactNode }) => (
        <Box sx={{ display: "flex", gap: 1.2, alignItems: "flex-start" }}>
            <Box
                sx={{
                    width: 34,
                    height: 34,
                    borderRadius: 2,
                    display: "grid",
                    placeItems: "center",
                    bgcolor: "rgba(239,108,0,0.12)",
                    color: "#ef6c00",
                    flex: "0 0 auto",
                    mt: "2px",
                }}
            >
                <FontAwesomeIcon icon={icon} />
            </Box>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.75 }}>
                {children}
            </Typography>
        </Box>
    );

    return (
        <Container maxWidth="lg" sx={{ mb: 8 }}>
            <SectionTitle title="ESPACE INFORMATIONS DES HABITANTS" />

            {/* --- HEADER / TITRE --- */}
            <Box mt={3} mb={5}>
                <Typography variant="h6" fontWeight={700} align="center" gutterBottom color="primary">
                    <FontAwesomeIcon icon={faBullhorn} style={{ marginRight: 8 }} />
                    VLD2026 - Présentation & engagement (14&nbsp;janvier&nbsp;2026)
                </Typography>
                <Divider sx={{ mt: 1, mb: 3 }} />
            </Box>

            <Stack spacing={8}>
                {/* --- HERO : PHOTO + INTRO --- */}
                <Paper
                    elevation={4}
                    sx={{
                        borderRadius: 4,
                        overflow: "hidden",
                        border: "1px solid rgba(25, 118, 210, 0.14)",
                        background:
                            "linear-gradient(135deg, rgba(13,71,161,0.06) 0%, rgba(25,118,210,0.03) 55%, rgba(67,160,71,0.05) 100%)",
                        boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
                    }}
                >
                    <Grid container alignItems="stretch">
                        {/* Texte */}
                        <Grid size={{ xs: 12, md: 7 }}>
                            <Box sx={{ p: { xs: 3, md: 4 }, height: "100%", display: "flex", flexDirection: "column" }}>
                                <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap sx={{ mb: 2 }}>
                                    <Pill icon={faMedal} label="Expérience" />
                                    <Pill icon={faUsers} label="Engagement local" />
                                    <Pill icon={faComments} label="Démocratie participative" />
                                </Stack>

                                {/* ⚠️ TITRE OK (inchangé) */}
                                <Typography variant="h4" fontWeight={900} color="#0d47a1" sx={{ mb: 1 }}>
                                    Mon engagement est fondé sur l'expérience
                                </Typography>

                                {/* ✅ TEXTE ORIGINAL — PAS DE REFORMULATION */}
                                <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.75, maxWidth: 720 }}>
                                    Docteur en sciences des matériaux, j'ai mis mon savoir-faire au service de la défense nationale et de
                                    l'industrie de mécanique de précision. J'ai eu la chance de gérer des équipes pluridisciplinaires.
                                    Parallèlement, j'ai aussi été secrétaire général de l'Institut Prospective et Sécurité de l'Europe, un poste
                                    qui m'a permis de développer des compétences d'organisation et de communication. Je suis officier de réserve.
                                    Il y a 26 ans, lorsque nous nous sommes installés à Bois-le-Roi, j'ai fait le choix avec mon épouse, de
                                    travailler à mon compte en tant que photographe professionnel, pour pouvoir m'occuper de nos 3 filles et lui
                                    permettre de se consacrer pleinement à son activité professionnelle.
                                </Typography>

                                <Box
                                    sx={{
                                        mt: 3,
                                        p: 2,
                                        borderRadius: 3,
                                        bgcolor: "rgba(255,255,255,0.7)",
                                        border: "1px solid rgba(0,0,0,0.08)",
                                    }}
                                >
                                    <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5} useFlexGap flexWrap="wrap">
                                        <Pill icon={faShieldHalved} label="Officier de réserve" />
                                        <Pill icon={faIndustry} label="Industrie & mécanique de précision" />
                                        <Pill icon={faPeopleGroup} label="Équipes pluridisciplinaires" />
                                        <Pill icon={faCamera as any} label="Photographe professionnel" />
                                    </Stack>
                                </Box>
                            </Box>
                        </Grid>

                        {/* Photo (✅ UNIQUE PHOTO ICI) */}
                        <Grid size={{ xs: 12, md: 5 }}>
                            <Box
                                sx={{
                                    position: "relative",
                                    height: { xs: 240, md: "100%" },
                                    minHeight: { md: 320 },
                                    bgcolor: "#0d47a1",
                                    overflow: "hidden",
                                }}
                            >
                                <img
                                    src={imgJpg}
                                    alt="Jean-Philippe Guibert"
                                    style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
                                />
                                <Box
                                    sx={{
                                        position: "absolute",
                                        inset: 0,
                                        background:
                                            "linear-gradient(90deg, rgba(13,71,161,0.18) 0%, rgba(13,71,161,0.06) 40%, rgba(0,0,0,0.18) 100%)",
                                    }}
                                />
                                <Box
                                    sx={{
                                        position: "absolute",
                                        bottom: 14,
                                        left: 14,
                                        bgcolor: "rgba(255,255,255,0.92)",
                                        border: "1px solid rgba(255,255,255,0.6)",
                                        px: 1.5,
                                        py: 0.8,
                                        borderRadius: 3,
                                        backdropFilter: "blur(6px)",
                                        boxShadow: "0 10px 20px rgba(0,0,0,0.15)",
                                    }}
                                >
                                    <Typography variant="caption" fontWeight={900} color="#0d47a1" sx={{ letterSpacing: 0.6 }}>
                                        Jean-Philippe Guibert
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Paper>

                {/* --- SECTION : ENGAGEMENT ÉPROUVÉ --- */}
                <Paper elevation={2} sx={{ p: 4, borderRadius: 4, borderLeft: "6px solid #43a047", bgcolor: "#fbfffb" }}>
                    <Stack direction="row" spacing={1.5} alignItems="center" mb={2}>
                        <Box
                            sx={{
                                width: 42,
                                height: 42,
                                borderRadius: 2,
                                display: "grid",
                                placeItems: "center",
                                bgcolor: "rgba(67,160,71,0.12)",
                                color: "#43a047",
                            }}
                        >
                            <FontAwesomeIcon icon={faCheckCircle} />
                        </Box>
                        <Typography variant="h5" fontWeight={900} color="#2e7d32">
                            Un engagement déjà éprouvé et reconnu
                        </Typography>
                    </Stack>

                    {/* ✅ TEXTE ORIGINAL (inchangé) */}
                    <Stack spacing={2.2}>
                        <Bullet icon={faUserTie}>
                            En 2018, j'ai accepté d'être adjoint chargé des affaires scolaires et périscolaires.
                            J'ai exercé cette mission suivant mes méthodes : toutes les délibérations concernant l'enfance ont été votées à
                            l'unanimité du conseil municipal.
                        </Bullet>

                        <Bullet icon={faSchool}>
                            Pendant la crise sanitaire, par mon action, et appuyé par les services, nous avons pu accueillir les enfants des personnels mobilisés et rouvrir le maximum de classes que permettait le protocole sanitaire, dans l'intérêt des élèves et des familles.
                        </Bullet>

                        <Bullet icon={faHandshakeAngle}>
                            Les conditions n'étant pas remplies pour que je poursuive sereinement ma mission, j'ai démissionné dès la fin de l'année scolaire 2020.
                        </Bullet>
                    </Stack>
                </Paper>

                {/* --- SECTION : POURQUOI CANDIDAT --- */}
                <Paper elevation={3} sx={{ p: 4, borderRadius: 4, borderLeft: "6px solid #ef6c00" }}>
                    <Stack direction="row" spacing={1.5} alignItems="center" mb={2}>
                        <Box
                            sx={{
                                width: 42,
                                height: 42,
                                borderRadius: 2,
                                display: "grid",
                                placeItems: "center",
                                bgcolor: "rgba(239,108,0,0.12)",
                                color: "#ef6c00",
                            }}
                        >
                            <FontAwesomeIcon icon={faFlag} />
                        </Box>
                        <Typography variant="h5" fontWeight={900} color="#ef6c00">
                            Pourquoi je suis candidat en mars 2026
                        </Typography>
                    </Stack>

                    {/* ✅ TEXTE ORIGINAL (inchangé) */}
                    <Stack spacing={2.2}>
                        <Bullet icon={faBullhorn}>
                            En novembre 2021, j'ai fait le nécessaire pour alerter et mobiliser les habitants afin de nous opposer à un projet de densification massive, au prétexte de la construction de logements sociaux; un projet irréversible, hors programme électoral, dissimulé à l'équipe municipale et sans préparation. Ce projet a été stoppé.
                        </Bullet>

                        <Box
                            sx={{
                                p: 3,
                                borderRadius: 3,
                                bgcolor: "#fff3e0",
                                border: "1px solid rgba(239,108,0,0.25)",
                            }}
                        >
                            <Typography variant="subtitle1" fontWeight={900} color="#e65100" sx={{ mb: 1 }}>
                                C'est dans ce contexte que j'ai créé :
                            </Typography>

                            <Stack spacing={1.2}>
                                <Box sx={{ display: "flex", gap: 1.2, alignItems: "center" }}>
                                    <Box sx={{ color: "#e65100" }}>
                                        <FontAwesomeIcon icon={faLandmark} />
                                    </Box>
                                    <Typography variant="body1" color="text.secondary">
                                        • L'association <b>Vivre la Démocratie</b>, pour vous informer et vous alerter,
                                    </Typography>
                                </Box>

                                <Box sx={{ display: "flex", gap: 1.2, alignItems: "center" }}>
                                    <Box sx={{ color: "#e65100" }}>
                                        <FontAwesomeIcon icon={faUsers} />
                                    </Box>
                                    <Typography variant="body1" color="text.secondary">
                                        • Le groupe Facebook <b>« Bois-le-Roi Infos sans censure »</b> pour vous permettre de partager vos opinions librement.
                                    </Typography>
                                </Box>
                            </Stack>
                        </Box>

                        <Paper
                            elevation={0}
                            sx={{
                                p: 3,
                                borderRadius: 3,
                                bgcolor: "#ffebee",
                                border: "1px solid rgba(198,40,40,0.25)",
                                position: "relative",
                            }}
                        >
                            <FontAwesomeIcon
                                icon={faTriangleExclamation}
                                style={{
                                    position: "absolute",
                                    top: 14,
                                    right: 14,
                                    fontSize: "1.4rem",
                                    color: "rgba(198,40,40,0.35)",
                                }}
                            />
                            <Typography variant="body1" fontWeight={900} color="#c62828" sx={{ mb: 1 }}>
                                Je suis candidat en mars 2026 car Bois-le-Roi est en danger et ces élections seront décisives.
                            </Typography>
                            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.75 }}>
                                Ce constat n'est ni excessif ni idéologique. Les finances communales sont à la dérive (Cf. notre tract précédent). Malgré des hausses d'impôts inédites, la commune n'a plus la capacité de fonctionner normalement ni même d'entretenir son patrimoine.
                            </Typography>
                        </Paper>

                        <Bullet icon={faPeopleGroup}>
                            J'ai constitué une équipe compétente, engagée et fidèle à des valeurs simples et exigeantes: travail, écoute, honnêteté, sens de l'engagement et défense de l'intérêt général, pour relever les défis qui nous attendent autour d'un vrai projet pour notre commune.
                        </Bullet>

                        <Bullet icon={faMedal}>
                            Si vous nous faites confiance en mars 2026, je m'organiserai pour être un maire à plein temps.
                        </Bullet>
                    </Stack>
                </Paper>

                {/* --- SECTION : DÉMOCRATIE PARTICIPATIVE --- */}
                <Paper elevation={3} sx={{ p: 4, borderRadius: 4, borderLeft: "6px solid #1565c0", bgcolor: "#f7fbff" }}>
                    <Stack direction="row" spacing={1.5} alignItems="center" mb={2}>
                        <Box
                            sx={{
                                width: 42,
                                height: 42,
                                borderRadius: 2,
                                display: "grid",
                                placeItems: "center",
                                bgcolor: "rgba(21,101,192,0.12)",
                                color: "#1565c0",
                            }}
                        >
                            <FontAwesomeIcon icon={faComments} />
                        </Box>
                        <Typography variant="h5" fontWeight={900} color="#1565c0">
                            La démocratie participative est le socle de notre projet
                        </Typography>
                    </Stack>

                    {/* ✅ TEXTE ORIGINAL (inchangé) */}
                    <Typography variant="body1" color="text.secondary" sx={{ mb: 3, lineHeight: 1.75 }}>
                        Restaurer la confiance entre les élus et les habitants repose sur trois principes essentiels: la transparence, l'écoute et des règles claires.
                    </Typography>

                    <Stack spacing={2.2}>
                        <Bullet icon={faBullhorn}>
                            Nous mettrons en place des réunions publiques régulières et des consultations citoyennes en amont des décisions importantes.
                        </Bullet>

                        <Bullet icon={faMagnifyingGlass}>
                            Un espace numérique sécurisé permettra de vous informer et de recueillir votre avis de manière simple et accessible.
                        </Bullet>

                        <Bullet icon={faClipboardList}>
                            Les projets structurants feront l'objet d'une concertation réelle, pouvant aller jusqu'au référendum local.
                        </Bullet>

                        <Bullet icon={faUserTie}>
                            Un référent dédié à la démocratie participative, ainsi qu'un bilan annuel public, garantiront le respect des engagements pris.
                        </Bullet>
                    </Stack>

                    <Box sx={{ mt: 3 }}>
                        <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.75 }}>
                            Vous souhaitez un exercice du pouvoir moins unilatéral, une gouvernance apaisée fondée sur la confiance et la transparence, alors soutenez et votez pour la liste Vivre la Démocratie de Jean-Philippe GUIBERT.
                        </Typography>
                    </Box>
                </Paper>

                {/* --- CONCLUSION / CTA --- */}
                <Paper
                    elevation={0}
                    sx={{
                        p: 6,
                        borderRadius: 4,
                        textAlign: "center",
                        background: "linear-gradient(135deg, #43a047 0%, #66bb6a 100%)",
                        color: "white",
                        boxShadow: "0 10px 30px rgba(67, 160, 71, 0.3)",
                    }}
                >
                    <FontAwesomeIcon icon={faUsers} size="3x" style={{ marginBottom: 18, opacity: 0.92 }} />
                    <Typography variant="h5" fontWeight={900} gutterBottom>
                        Une commune bien gérée, c'est une commune qui peut investir, innover et soutenir ses habitants.
                    </Typography>
                    <Typography variant="h6" fontWeight={400} sx={{ mt: 1.5, opacity: 0.92, maxWidth: 900, mx: "auto" }}>
                        Faisons de la démocratie participative un levier d'avenir !
                    </Typography>

                    <Box sx={{ mt: 3 }}>
                        <Button
                            component={Link}
                            to="/contactez-nous"
                            variant="contained"
                            sx={{
                                borderRadius: 3,
                                textTransform: "none",
                                fontWeight: 900,
                                px: 3,
                                py: 1.2,
                                bgcolor: "rgba(255,255,255,0.92)",
                                color: "#2e7d32",
                                "&:hover": { bgcolor: "white" },
                            }}
                        >
                            Nous écrire / nous rencontrer
                        </Button>
                    </Box>
                </Paper>
            </Stack>
        </Container>
    );
};

export default POST20260114;
